import Fuse from "fuse.js";

const fuseOptions = {
  keys: [
    { name: "title", weight: 0.38 },
    { name: "brand", weight: 0.24 },
    { name: "jewellery", weight: 0.14 },
    { name: "metal", weight: 0.07 },
    { name: "gemstone", weight: 0.07 },
    { name: "description", weight: 0.06 },
    { name: "sku", weight: 0.02 },
    { name: "brandRef", weight: 0.02 },
  ],
  threshold: 0.6,
  ignoreLocation: true,
  includeScore: true,
  ignoreDiacritics: true,
  minMatchCharLength: 1,
};

/**
 * Fuzzy filter + relevance sort. Multi-word queries use AND (each word must match somewhere).
 */
export function fuzzySearchProducts(products, rawQuery) {
  const query = (rawQuery || "").trim();
  if (!query) {
    return [...products];
  }

  const fuse = new Fuse(products, fuseOptions);
  const tokens = query.split(/\s+/).filter(Boolean);

  if (tokens.length === 1) {
    return fuse.search(tokens[0]).map((r) => r.item);
  }

  let candidateIds = null;
  const scoreSum = new Map();

  for (const token of tokens) {
    const hits = fuse.search(token);
    const hitScores = new Map(
      hits.map((h) => [h.item.id, h.score ?? 0])
    );
    const matchedIds = new Set(hitScores.keys());

    if (candidateIds === null) {
      candidateIds = matchedIds;
      hitScores.forEach((score, id) => scoreSum.set(id, score));
    } else {
      candidateIds = new Set(
        [...candidateIds].filter((id) => matchedIds.has(id))
      );
      candidateIds.forEach((id) => {
        scoreSum.set(
          id,
          (scoreSum.get(id) ?? 0) + (hitScores.get(id) ?? 0)
        );
      });
    }
  }

  if (!candidateIds || candidateIds.size === 0) {
    return [];
  }

  const byId = new Map(products.map((p) => [p.id, p]));

  return [...candidateIds]
    .map((id) => byId.get(id))
    .filter(Boolean)
    .sort((a, b) => (scoreSum.get(a.id) ?? 0) - (scoreSum.get(b.id) ?? 0));
}
